var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button-icon',{class:_vm.classP,attrs:{"icon":"mdi-cancel","disabled":_vm.disabled,"loading":_vm.loading}},[(_vm.isSlot)?[_vm._t("default")]:[_vm._v(" Anuliuoti ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }